import { Message } from 'src/models/message';

import { Callback } from 'src/util/query/models/Callback';

export class MessageCallback extends Callback<Message> {
	public constructor(
		private readonly getMessageByAggregateId: (aggregateId: string) => Message | undefined,
		private readonly setMessage: (message: Message | null) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Message): void => {
		const existingMessage = this.getMessageByAggregateId(successResponse.aggregateId);

		if (existingMessage !== undefined && existingMessage.aggregateId !== successResponse.aggregateId) {
			return;
		}

		this.setMessage(successResponse);
	};
}
